import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Divider from '@components/Divider';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CartItem from './CartItem';
import EnabledItemsTitle from './EnabledItemsTitle';
import useCartItems from './hooks/useCartItems';
import SoldOutItemsTitle from './SoldOutItemsTitle';

interface Props {
    shopId: string;
    cartId: string;
}

function CartItems({ shopId, cartId }:Props) {
    const {
        enableItemQty,
        soldOutItemQty,
        sortedEnableItems,
        sortedSoldOutItems,
        isSoldOutItemBlank,
    } = useCartItems();

    return (
        <Fragment>
            <Accordion initialOpen
                title={<EnabledItemsTitle enableItemQty={enableItemQty}/>}>
                <Column fullWidth as='section' spacing={24}>
                    {sortedEnableItems.map((item) => (
                        <CartItem item={item} key={item.cartItemId}/>
                    ))}
                </Column>
            </Accordion>
            {(!isSoldOutItemBlank) && (
                <Fragment>
                    <Divider/>
                    <Accordion initialOpen
                        title={<SoldOutItemsTitle soldOutItemQty={soldOutItemQty} />} >
                        <Column fullWidth as='section' spacing={24}>
                            {sortedSoldOutItems.map((item) => (
                                <CartItem item={item}
                                    key={item.cartItemId}/>
                            ))}
                        </Column>
                    </Accordion>
                </Fragment>
            ) }
        </Fragment>
    );
}

export default CartItems;
